import React from "react";
import { Card } from "../ui/card";
import { X } from "lucide-react";
import { HEROES } from "../../data/heroes";

const GameShell = ({ children, hero, title, onClose, footer }) => {
  const tr = HEROES[hero];
  return (
    <Card className="bs-glass border-0 overflow-hidden">
      <div className={`h-1.5 bg-gradient-to-r ${tr.gradient}`} />
      <div className="p-4 sm:p-6">
        <div className="flex items-center justify-between mb-4 gap-2">
          <div className="flex items-center gap-3 min-w-0">
            <div className={`hero-avatar w-10 h-12 sm:w-12 sm:h-14 ${tr.imageBg} flex-shrink-0`}>
              <img src={tr.image} alt="" />
            </div>
            <h3 className="bs-title font-extrabold text-base sm:text-xl leading-tight truncate">{title}</h3>
          </div>
          <button onClick={onClose} className="bs-chip" data-testid="game-close-btn" aria-label="close game">
            <X className="w-4 h-4" />
          </button>
        </div>
        {children}
        {footer}
      </div>
    </Card>
  );
};

export default GameShell;
export const pick = (lang, obj) =>
  typeof obj === "string" ? obj : obj?.[lang] ?? obj?.en ?? "";
